import { CritiqueSessionList } from '../components/composed/CritiqueSessionList/CritiqueSessionList';
import { ErrorBoundary } from '../components/ErrorBoundary';

/**
 * CritiqueFeedPage - My Critiques Page
 * Feature: 055-my-critiques-page
 *
 * Displays all critique sessions owned by the current user.
 * Replaces the old public critique feed with a personalized session list.
 *
 * Each session shows:
 * - Collection hero image
 * - Session title
 * - Up to 5 most recent comments
 *
 * Clicking a session navigates to /crit/:sessionId/:slug
 */
export function CritiqueFeedPage() {
  return (
    <ErrorBoundary>
      <CritiqueSessionList />
    </ErrorBoundary>
  );
}
